<script setup>
  import { computed, inject } from "vue";
  import { useReviewCommentsStore } from "@stores/survey/reviewComments";
  import { useSurveyCardsStore } from "@stores/survey/surveyCards";
  import { segmentMentions, segmentCardNames } from "./mentionSegments";

  const props = defineProps({ body: { type: String, default: "" } });

  const store = useReviewCommentsStore();
  const cardsStore = useSurveyCardsStore();
  const reviewEventBus = inject("reviewEventBus", null);
  const segments = computed(() =>
    segmentMentions(props.body ?? "", store.mentionableUsers).flatMap((segment) =>
      segment.mention ? [segment] : segmentCardNames(segment.text, cardsStore.cards ?? []),
    ),
  );
  const goToCard = (token) => reviewEventBus?.emit({ command: "select", token });
</script>

<template>
  <span
    ><template
      v-for="(segment, index) in segments"
      :key="index"
      ><span
        v-if="segment.mention"
        class="font-medium text-status-info-strong"
        >{{ segment.text }}</span
      ><button
        v-else-if="segment.token"
        type="button"
        class="font-semibold text-episto-teal-700 underline underline-offset-2"
        @click.stop="goToCard(segment.token)">
        {{ segment.text }}</button
      ><span v-else>{{ segment.text }}</span></template
    ></span
  >
</template>
